// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"Select_custom_select__2St9Q","custom_select_arrow":"Select_custom_select_arrow__q0ohy","custom_select_dropdown":"Select_custom_select_dropdown__qO2Lf"};